export default __webpack_public_path__ + "static/media/Arrow_Right.37cb3778.svg";